import React, { useEffect, useState } from 'react';
import AcademicUserRegistration from './AcademicUserRegistration';
import RegistrationOptions from './RegistrationOptions';
import RegularUserRegistration from './RegularUserRegistration';
import Companysignup from '../../businessSignUp/BusinessSignUp';

const Register = () => {
  const [registerView, setRegisterView] = useState(1);

  useEffect(() => {
    const referralId = localStorage.getItem('referralId');
    if (referralId) {
      setRegisterView(3);
    }
  }, []);

  const registerUser = (value) => {
    setRegisterView(value);
  };

  const renderView = () => {
    switch (registerView) {
      case 1:
        return <RegistrationOptions registerBtn={registerUser} />;
      case 2:
        return <AcademicUserRegistration registerBtn={registerUser} />;
      case 3:
        return <RegularUserRegistration registerBtn={registerUser} />;
      case 4:
        return <Companysignup registerBtn={registerUser} />;
      default:
        return <RegistrationOptions registerBtn={registerUser} />;
    }
  };

  return renderView();
};

export default Register;
